export default {
  'август': 'August',
  'Авто и мото': 'Auto & Moto',
  'Аксессуары': 'Accessories',
  'Акции и промокоды': 'Deals and promo codes',
  'Акции': 'Promotions',
  'акция': 'promotion',
  'апрель': 'April',
  'А так же воспользуйтесь Кэшбеком, чтобы сэкономить еще больше!': 'Also use Cashback to save even more!',
  'Банки и финансы': 'Banking & Finance',
  'в других странах': 'other countries',
  'В избранное': 'Add to favorites',
  'Вакансии': 'Vacancy',
  'Ваш голос учтен, спасибо': 'Your vote counted, thanks',
  'Введите название магазина, например': 'Enter the name of the store, for example',
  'Все промокоды': 'All Coupons',
  'Главная': 'Main',
  'д.': 'd.',
  'Да': 'Yes',
  'Действует': 'Valid',
  'Действует до': 'Expires',
  'декабрь': 'December',
  'Детские товары': "Kids",
  'Для взрослых': 'Adults',
  'Для офиса': 'Office',
  'Добавлено в избранное': 'Added to favorites',
  'Дом и сад': 'Home & Garden',
  'Еда и напитки': 'Food & Drinks',
  'Животные и растения': 'Animals & Plants',
  'за': 'for',
  'Здоровье и красота': 'Health & Beauty',
  'Игры': 'Games',
  'июль': 'July',
  'июнь': 'June',
  'Как это работает': 'How it works',
  'Категории': 'Categories',
  'Книги': 'Books',
  'Контакты': 'Contacts',
  'Копировать': 'Copy',
  'Криптовалюты': 'Cryptocurrencies',
  'Кэшбэк': 'Cashback',
  'кэшбэка дополнительно': 'extra cashback',
  'Лучшие предложения по кэшбэку': 'Best Cashback Deals',
  'Магазины': 'Stores',
  'май': 'May',
  'март': 'March',
  'Мебель': 'Furniture',
  'Меньше': 'Less',
  'Мобильные приложения': 'Mobile Apps',
  'Моллы': 'Malls',
  'Музыка и фильмы': 'Music & Movies',
  'Нажмите "Показать промокод" скопируйте его и используйте': "Click «Show Coupon Code» copy it and use on shop's checkout page",
  'Найдите нужный вам магазин, через наш поиск': 'Find your store, through our search',
  'Нет': 'Not',
  'ноябрь': 'November',
  'О нас': 'About Us',
  'Облачный майнинг': 'Cloud Mining',
  'Обувь': 'Shoes',
  'Одежда': 'Clothing',
  'октябрь': 'October',
  'оценка': 'Rating',
  'Перейти в магазин': 'Go to the store',
  'Подберите промокод, который вам подходит': 'Choose a promotional code that suits you',
  'Показать ещё': 'Show More',
  'Показать код': 'Show code',
  'Показать промокод': 'Show Coupon Code',
  'Получите до': 'Get up to',
  'Получить': 'Receive',
  'Получить скидку': 'Get Deal',
  'Пользовательское соглашение': 'Terms of use',
  'Популярные магазины': 'Popular Stores',
  'Похожие купоны': 'Similar coupons',
  'Предложений активно': 'Active offers',
  'промокод': 'promocode',
  'Промокод не нужен': 'No code needed',
  'Промокод сработал': 'Did this help you to save money',
  'Промокод': 'Promocode',
  'Промокоды': 'Promocodes',
  'Рейтинг': 'Rating',
  'сентябрь': 'September',
  'Сервисы для вебмастеров': 'Services for webmasters',
  'Скидки и акции': 'Discounts & Promotions',
  'Скопировано': 'Copied',
  'Скопируйте и вставьте этот код на': 'Copy and paste this code into',
  'Спасибо за ваш голос': 'Thank you for your vote',
  'Спорт': 'Sport & Fitnes',
  'Стройка и ремонт': 'Construction & Repair',
  'Товары из Китая': 'Chinese Products',
  'Только сегодня': 'Only today',
  'Топ купонов': 'Top Coupons',
  'Туризм': 'Travel',
  'Услуги': 'Services',
  'февраль': 'February',
  'Цветы и подарки': 'Flowers & Gifts',
  'ч.': 'h.',
  'Читать подробнее': 'Read more',
  'Электроника': 'Electronics',
  'январь': 'January',
}